import React, { Component } from 'react';
import classNames from 'classnames';
import { Route, Switch } from "react-router-dom";
import { AppTopbar } from '../../AppTopbar';
import { AppFooter } from '../../AppFooter';
import { AppMenu } from '../../AppMenu';
import { AppProfile } from '../../AppProfile';
import '../../layout/layout.scss';
import '../../App.css';

import servicioMenu from '../servicios/ServicioMenu';
import Nru from '../app/RecuperaNru';
import EditarContrasena from '../app/EditarContrasena';
import Carril from '../app/Carril';
import Emisor from '../app/Emisor';
import PlazaCobro from '../app/PlazaCobro';
import Parametros from '../app/Parametros';
import Series from '../app/Series';
import Receptor from '../app/Receptor';
import Permisos from '../app/Permisos';
import Perfil from '../app/Perfil';
import Usuario from '../app/Usuario';
import Bitacora from '../app/Bitacora';
import ConsultasCfdi from '../app/ConsultasCfdi';
//import FacturacionRegistro from '../app/FacturacionRegistro';
import {FacturacionConRegistro} from '../app/facturaciontickets/FacturacionConRegistro';
import FacturacionOtrosIngresos from '../app/FacturacionOtrosIngresos';
import CancelacionCfdi from '../app/CancelacionCfdi';
import Cargaxmltimbradoporfuera from '../app/Cargaxmltimbradoporfuera';
import { Dialog } from 'primereact/dialog';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
import { Growl } from 'primereact/growl';
import { Password } from 'primereact/password';

import {Consultas} from '../consultas/Consultas';
import {ReporteExtemporaneo} from '../consultas/reporteExtemporaneo/ReporteExtemporaneo';

export class Bienvenido extends Component {
    constructor() {
        super();
        this.state = {
            layoutMode: 'static',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            mostrarModalCambio:false,
            objetoUsuario:{},
            twUsuario:{},
            errores:{}
        };

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.cambiaContrasena = this.cambiaContrasena.bind(this);
        servicioUsuario.cambiosContrasena().then(response=>{
        if(response.data){
            this.setState({mostrarModalCambio:true});
        }
            
        }).catch(error=>{

        })
        servicioMenu.buscarMenu().then(response=>{
            console.log(response.data);
            this.createMenu(response.data);
        }).catch(error=>{

        })
        
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }
        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;
        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            }
            else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        }
        else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }
        event.preventDefault();
    }

    onSidebarClick(event) {
        this.menuClick = true;
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    createMenu(lista) {
        let menus=[];
        lista.map(permiso=>{
            return menus.push({ label: permiso.nombre, icon: permiso.icono, command: () => { this.props.history.push(permiso.accion) } })
        });
        this.menu = menus ;    
        this.setState({
            overlayMenuActive: false,
            mobileMenuActive: false
        });
    }

    addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate() {
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }
    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    validarFormulario = (objeto) => {
        const errores = {};
        if (!objeto.contrasena)
            errores.contrasena = "La contraseña es requerida";
        if (!objeto.contrasena2)
            errores.contrasena2 = "La confirmación es requerida";
        if (objeto.contrasena !== objeto.contrasena2)
            errores.contrasena2 = "Las contraseñas no coinciden";
        return errores;
    }
    cambiaContrasena(){
        const { objetoUsuario, twUsuario} = this.state;

        const validacion = this.validarFormulario(objetoUsuario);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            twUsuario.contrasena=objetoUsuario.contrasena;
            servicioUsuario.guardaCambioContrasena(twUsuario).then(response=>{
                this.growl.show({ severity: 'success', summary: 'Exito', detail: 'Se cambio exitosamente la contraseña' });
                localStorage.removeItem("auth");
                window.location = '/facturacionbanobras';
                this.setState({mostrarModalCambio:false});   
                }).catch(error=>{
                    this.growl.show({ severity: 'error', summary: 'Error', detail: 'No se cambio la contraseña' });
                })
        }
    }

    render() {
       

        const wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });

        const sidebarClassName = classNames("layout-sidebar", {
            'layout-sidebar-dark': this.state.layoutColorMode === 'dark',
            'layout-sidebar-light': this.state.layoutColorMode === 'light'
        });
        const { objetoUsuario,errores } = this.state;
        return (
            <div className={wrapperClass} onClick={this.onWrapperClick}>
                <AppTopbar onToggleMenu={this.onToggleMenu} />
                <div ref={(el) => this.sidebar = el} className={sidebarClassName} onClick={this.onSidebarClick}>
                    <AppProfile />
                    <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                </div>
                <div className="layout-main">
                    <Route>
                        <Switch>
                            <Route path="/facturacionbanobras/bienvenido/carril" component={Carril} />
                            <Route path="/facturacionbanobras/bienvenido/emisor" component={Emisor} />
                            <Route path="/facturacionbanobras/bienvenido/plazacobro" component={PlazaCobro}/>
                            <Route path="/facturacionbanobras/bienvenido/parametros" component={Parametros}/>
                            <Route path="/facturacionbanobras/bienvenido/series"component={Series}/>
                            <Route path="/facturacionbanobras/bienvenido/receptor"component={Receptor}/>
                            <Route path="/facturacionbanobras/bienvenido/permisos"component={Permisos}/>
                            <Route path="/facturacionbanobras/bienvenido/perfil" component={Perfil}/>
                            <Route path="/facturacionbanobras/bienvenido/usuario" component={Usuario}/>
                            <Route path="/facturacionbanobras/bienvenido/cfdiConsultas" component={ConsultasCfdi}/>
                            <Route path="/facturacionbanobras/bienvenido/facturacion" component={FacturacionConRegistro}/>
                            <Route path="/facturacionbanobras/bienvenido/facturacionOtrosIngresos" component={FacturacionOtrosIngresos}/>
                            <Route path="/facturacionbanobras/bienvenido/cancelacion" component={CancelacionCfdi}/>
                            <Route path="/facturacionbanobras/bienvenido/cargaxml" component={Cargaxmltimbradoporfuera}/>
                            <Route path="/facturacionbanobras/bienvenido/recuperaNru" component={Nru}/>
                            <Route path="/facturacionbanobras/bienvenido/miCuenta" component={EditarContrasena}/>
                            <Route path="/facturacionbanobras/bienvenido/bitacora" component={Bitacora}/>
                            <Route path="/facturacionbanobras/bienvenido/consultas2023" component={Consultas}/>
                            <Route path="/facturacionbanobras/bienvenido/reporteextemporaneos" component={ReporteExtemporaneo}/>
                        </Switch>
                    </Route>
                </div>
                <AppFooter />
                <div className="layout-mask"></div>
                <Growl ref={(el) => this.growl = el} />
            <Dialog header="Cambio de contraseña" visible={this.state.mostrarModalCambio} style={{ width: '35vw' }}  maximizable>
          <ScrollPanel style={{ width: '100%', height: '270px' }}>
            <div className="p-grid p-fluid">
            
              <div className="p-col-12 p-md-12">
                <h4>Contraseña:</h4>
                <Password id="objetoUsuario.contrasena" name="objetoUsuario.contrasena" value={objetoUsuario.contrasena || ''} className={errores.contrasena ? 'p-error' : ''} onChange={this.asignarValoresObjeto} />
                {errores.contrasena ? <div> <Message severity="error" text={errores.contrasena} /> </div> : null}
              </div>

              <div className="p-col-12 p-md-12">
                <h4>Confirmar Contraseña:</h4>
                <Password id="contrasena2" name="objetoUsuario.contrasena2" value={objetoUsuario.contrasena2 || ''} className={errores.contrasena2 ? 'p-error' : ''} onChange={this.asignarValoresObjeto} />
                {errores.contrasena2 ? <div> <Message severity="error" text={errores.contrasena2} /> </div> : null}
              </div>
              
            </div>

            <br />
            <div className="p-grid" style={{ width: "100%" }}>
              <div className="p-col"></div>
              <div className="p-col"></div>
              <div className="p-col ">
                <Button label="Aceptar" onClick={this.cambiaContrasena} icon="pi pi-check" />
              </div>
             
            </div>
          </ScrollPanel>
        </Dialog>

            </div>
        );
    }
}

export default Bienvenido;